@switch (currentSettings) {
    @case (settingEnum.MAIN) {
        <web-widget-breadcrumbs [widget]="widget" [isInSpecificSection]="isSpecific"></web-widget-breadcrumbs>
        <div class="panel-options-body overflow-wrapper">
            <div class="form form-horizontal">
                @if (isRemovedFromCatalog) {
                    <div class="removed-from-catalog-notice">
                        <p class="text">{{ "widget_product_removed_from_catalog_hint" | translate }}</p>
                        <button type="button" class="btn btn-action btn-block" (click)="openCatalogModal()">
                            {{ "widget_product_choose_product" | translate }}
                        </button>
                    </div>
                }
                @if (isShowCardSettings) {
                    <web-card-settings
                        [data]="data"
                        [widgetId]="getWidgetId(widget)"
                        [displayId]="displayId"
                        (updateWidgetDisplayId)="updateWidgetDisplayId($event)"
                        (setCurrentSettingsType)="setCurrentSettingsType($event)"
                        (editProductCard)="openProductModal(true)"
                        (openCatalogEvent)="openCatalogModal()"
                    >
                    </web-card-settings>
                } @else {
                    <div>
                        <label>{{ "widget_product_card_label" | translate }}</label>
                        <select class="form-control mb-10" (change)="setCreateCardOption($event.target['value'])">
                            <option [value]="CreateCardOption.create" [selected]="isNewCardOption">
                                {{ "widget_product_create_product" | translate }}
                            </option>
                            <option [value]="CreateCardOption.catalog" [selected]="isCatalogOption">
                                {{ "widget_products_catalog" | translate }}
                            </option>
                        </select>
                        @if (isNewCardOption) {
                            <button type="button" class="btn btn-action btn-block" (click)="openProductModal()">
                                {{ "widget_product_create_product_button" | translate }}
                            </button>
                        }
                        @if (isCatalogOption) {
                            <button type="button" class="btn btn-action btn-block" (click)="openCatalogModal()">
                                {{ "widget_product_choose_product" | translate }}
                            </button>
                        }
                    </div>
                }
            </div>
        </div>
    }
    @case (settingEnum.BUTTON) {
        <web-button-settings
            [itemForm]="basketButton"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
        ></web-button-settings>
    }
    @case (settingEnum.SHOW_MORE_BUTTON) {
        <web-button-settings
            [itemForm]="showMoreButton"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
        ></web-button-settings>
    }
    @case (settingEnum.CARD) {
        <web-product-settings
            [widgetId]="getWidgetId(widget)"
            [itemForm]="cardSettings"
            [cardKindViewType]="cardKindViewType.value"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
        >
        </web-product-settings>
    }
    @case (settingEnum.PREVIEW) {
        <web-preview-modal-settings
            [itemForm]="previewModalSettings"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
        ></web-preview-modal-settings>
    }
    @case (settingEnum.MODAL) {
        <web-modal-settings
            [itemForm]="modalSettings"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
            [data]="widgetData"
            [classes]="classes"
        ></web-modal-settings>
    }
}
